export class StateProvince {
  public Abbreviation: string;
  public Name: string;
  public Country: string;
  public constructor() {
    this.Abbreviation = '';
    this.Name = '';
    this.Country = '';
  }
  public toString(){
    return this.Name
  }
}
